<!-- @for (id of ids(); track $index) {
  <ideal-product-result-layout [productId]="id" [layout]="itemLayout()" *ifInViewport />
} -->

<ideal-infinite-grid-layout [data]="ids()" [layoutStrategy]="colStrategy">
  <div *gridCell="let id">
    <ideal-product-result-layout [productId]="id" [layout]="itemLayout()" />
  </div>
</ideal-infinite-grid-layout>
